import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ViolationModel, } from '../../../../shared/violation-interface';
import { ActivatedRoute } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { ExcelService } from '../../scrumboard/excel.service';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-team-violation',
  templateUrl: './team-violation.component.html',
  styleUrls: ['./team-violation.component.scss'],
  animations: fuseAnimations
})

export class TeamViolationComponent implements OnInit {

  reportingToDD = [];
  datas: any[];
  userId = this.parseService.instance.User.current().id;
  timeSheetData = [];
  selectedDate: Date;
  sample = [];
  todayDate = new Date();
  selectbydate = new Date(this.todayDate.setDate(this.todayDate.getDate() - 1));
  reportingList = [];
  resourcesList: string[] = [];
  reportingToOptions: SelectItem[];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  profileValue: any;
  startingTime: any;
  objectId = '';
  graceStartTime: any;
  startTime: Date;
  profileId = '';
  violationsData: ViolationModel[] = [];
  resourceCount: any;
  inTimeCount = 0;
  inCompletedHrsCount = 0;
  breakHrsCount = 0;
  maxDate = new Date();
  typeSelectItem: SelectItem[];
  selectedType = 'all';
  selectedResources = '';
  empRole = '';
  statusSelectItem: SelectItem[];
  selectedRepotee = 'all';
  selectedStatus = 'all';
  todoCols = [
    { field: 'position', header: 'Position' },
    { field: 'userName', header: 'User Name' },
    { field: 'violations', header: 'Violations' },
    { field: 'reporter', header: 'Reporting To' }
  ];
  violationResults = [];
  excelData = [];
  violationCount = 0;
  date = new Date();
  selectViolationDate = new Date(this.date.setDate(this.date.getDate() - 1));
  yesterdayDate = new Date(this.date.setDate(this.date.getDate()));
  nonWorkingDays = [];
  violationTypes = [
    { label: 'In Completed Hours', value: 'In Completed Hours' },
    { label: 'Internal Meeting Hours', value: 'Internal Meeting Hours' },
    { label: 'Break Hours', value: 'Break Hours' },
  ];
  tenantId: any;


  constructor(
    private parseService: ParseService,
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration,
    private getReportingToService: GetReportingToService,
    private excelService: ExcelService,
    private dateService: DateServiceService,
    private toastr: ToastrService
  ) {


  }

  ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.route.params.subscribe(params => {
      let date;
      date = params['date'];
      if (date != undefined && date != null) {
        this.selectbydate = new Date(date);
      }
    });
    this.statusSelectItem = [
      { label: 'All', value: 'all' },
      { label: 'Open', value: 'open' },
      { label: 'Resolved', value: 'resolved' },
      { label: 'Escalated', value: 'escalated' }
    ];
    this.typeSelectItem = [
      { label: 'All', value: 'all' },
      { label: 'In Time', value: 'In-Time' },
      { label: 'Incompleted Hours', value: 'Incompleted-Hours' },
      { label: 'Break Hours', value: 'Exceeded-Break-Hours' }
    ];
    this.getReportingTo();
    this.getEmployeeDropDown();
    this.getViolationsByDateName(this.selectbydate, '', this.selectedType);
    this.getResourceCount();
    this.getHolidays();

    this.getEmployees();
  }

  getResourceCount() {
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('isActive', true);
    query.equalTo('tenantId', this.tenantId);
    if (this.empRole == 'Leader' || this.empRole == 'IT Manager') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    }
    query.count().then(results => {
      this.resourceCount = results;
    });
  }

  getViolationById(event) {
    let queryInstance = this.parseService.instance.Object.extend('UserViolations');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('userProfileId', { __type: 'Pointer', className: 'Profile', objectId: event });
    // this.getViolations(query);
  }

  getViolationsByDateName(event, id, type) {
    if (id != '' && id != null) {
      this.selectedResources = id;
    } else {
      this.selectedResources = '';
    }
    let queryInstance = this.parseService.instance.Object.extend('UserViolations');
    let query = new this.parseService.instance.Query(queryInstance);
    let today = new Date(event);
    let startend = this.startenddates(today);
    query.equalTo('tenantId', this.tenantId);
    query.greaterThan('violatedDate', startend[0]);
    query.lessThan('violatedDate', startend[1]);
    if (id != '' && id != null && id != 'all') {
      query.equalTo('userProfileId', { __type: 'Pointer', className: 'Profile', objectId: id });
    }
    this.getViolations(query, type);
  }

  getViolations(query, type) {
    this.violationsData = [];
    let violateValue = [];
    query.include('userProfileId');
    query.include('reportingTo');
    query.include('userProfileId.role');
    query.descending('updatedAt');
    query.equalTo('tenantId', this.tenantId);
    query.limit(1000000);
    if (this.empRole == 'Leader' || this.empRole == 'IT Manager') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    }
    query.find().then(results => {
      let violations = [];
      results.forEach(element => {
        let violate: ViolationModel = new ViolationModel();
        let vDate = element.get('violatedDate');
        violate.violatedDate = new Date(vDate);
        violate.userProfileId = element.get('userProfileId');
        violate.startTime = element.get('userProfileId').get('officialInfo').startTime;
        violate.violations = element.get('violations');
        violate.status = element.get('status');
        violate.reportingTo = element.get('reportingTo');
        violate.resolvedBy = element.get('resolvedBy');
        violate.resolvedDate = element.get('resolvedDate');
        violate.objectId = element.id;
        violations.push(violate);
      });
      violateValue = violations;
      if (type != '' && type != 'all') {
        let arrayValue = [];
        // violations = violateValue.filter(a => a.violations.filter(s => s.type == type));
        violateValue.forEach(element => {
          element.violations.forEach(innerElement => {
            if (innerElement.type == type) {
              arrayValue.push(element);
            }
          });
        });
        violations = arrayValue;

      } else {
        violations = violations;
      }
      this.violationsData = violations;

      this.inTimeCount = 0;
      this.inCompletedHrsCount = 0;
      this.breakHrsCount = 0;
      violations.forEach(element => {
        element.violations.forEach(innerElement => {
          if (innerElement.type == 'In-Time') {
            this.inTimeCount += 1
          }
          if (innerElement.type == 'Incompleted-Hours') {
            this.inCompletedHrsCount += 1
          }
          if (innerElement.type == 'Exceeded-Break-Hours') {
            this.breakHrsCount += 1
          }
        });
      });

    });
  }

  getEmployeeDropDown() {
    let data = [];
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('isActive', true);
    query.limit(2000);
    query.ascending('firstName');
    query.equalTo('tenantId', this.tenantId);
    if (this.empRole == 'Leader' || this.empRole == 'IT Manager') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    }
    query.find().then(results => {
      for (let i = 0; i < results.length; i++) {
        var username = results[i].get('firstName') + ' ' + results[i].get('lastName');
        var objectId = results[i].id;
        data.push({ name: username, value: objectId });

        this.resourcesList = data;
      }
      this.getFilteredValue();
    });
  }

  getFilteredValue() {
    if (this.resourcesList.length > 0) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(skillSets => this._filter(skillSets))
      );
    }
  }

  private _filter(value: string): any[] {
    let userRole1 = JSON.stringify(this.resourcesList);
    let userRole = JSON.parse(userRole1);
    const filterValue = value.toLowerCase();
    return userRole.filter(option => option.name
      .toString()
      .toLowerCase()
      .includes(filterValue)
    );
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  getViolationsByDate(event, id, status, type) {
    this.getAdminResourceCount(id);
    let queryInstance = this.parseService.instance.Object.extend('UserViolations');
    let query = new this.parseService.instance.Query(queryInstance);
    let today = new Date(event);
    let startend = this.startenddates(today);
    query.greaterThan('violatedDate', startend[0]);
    query.lessThan('violatedDate', startend[1]);
    query.descending('updatedAt');
    query.equalTo('tenantId', this.tenantId);
    if (status != 'all') {
      query.equalTo('status', status);
    }
    if (id != '' && id != null && id != 'all') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: id });
    }
    this.getViolations(query, type);
  }

  getAdminResourceCount(id) {
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('isActive', true);
    query.equalTo('tenantId', this.tenantId);

    if (id != '' && id != null && id != 'all') {
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: id });
    }
    query.count().then(results => {
      this.resourceCount = results;
    });
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToDD = res;
      this.reportingToOptions = this.bindDropDown1(res);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  async getEmployees() {
    let thisYear = new Date(this.selectViolationDate).getFullYear();
    let thisMonth = new Date(this.selectViolationDate).getMonth();
    let thisDate = new Date(this.selectViolationDate).getDate();
    let today = new Date(thisYear, thisMonth, thisDate);
    let todayDate = today.getTime();
    let holiday = this.nonWorkingDays.filter(x => x == todayDate);

    if (holiday.length == 0) {
      this.violationResults = [];
      let skipingUsers = ['y5RtBckAm2', 'BCAUtQsWO3', 'BVXvot0K5u', 'YHzF0bue0c'];
      let queryInstance = this.parseService.instance.Object.extend('Profile');
      let profileQuery = new this.parseService.instance.Query(queryInstance);
      profileQuery.equalTo('isActive', true);
      profileQuery.equalTo('isLongLeave', false);
      profileQuery.equalTo('tenantId', this.tenantId);
      profileQuery.notContainedIn('objectId', skipingUsers);
      profileQuery.limit(10000);
      let profileResults = await profileQuery.find();

      let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
      let timesheetQuery = new this.parseService.instance.Query(timeSheet);
      timesheetQuery.include('user');
      timesheetQuery.include('user.profile');
      let dateDifferent = this.dateService.startEndDateByDate(new Date(this.selectViolationDate));
      timesheetQuery.greaterThan('createdAt', dateDifferent[0]);
      timesheetQuery.lessThan('createdAt', dateDifferent[1]);
      timesheetQuery.equalTo('tenantId', this.tenantId);
      timesheetQuery.limit(10000);
      let timesheetResults = await timesheetQuery.find();

      for (const element of profileResults) {
        let currentProfile = timesheetResults.filter(profile => profile.get('profileId').id == element.id);
        if (currentProfile.length > 0) {
          let totalAttendance = currentProfile[0].get('totalAttendance');
          let breakTime = currentProfile[0].get('breakTime');
          let incompletedHours = 28800 - totalAttendance.worktime;
          let breakHours = element.breakHours;
          let internalMeetingArray = breakTime.filter(x => x.reason.reason == 'Internal Meeting');
          let internalMeetingHours = 0;
          let internalMeeting = 0;
          if (internalMeetingArray.length > 0) {
            internalMeeting = internalMeetingArray.map(item => item.breakHours).reduce((prev, next) => prev + next);
          }
          internalMeetingHours = (internalMeeting / 1000)
          let modalObject = {
            id: element.id,
            userName: element.get('firstName') + ' ' + element.get('lastName'),
            inCompletedHours: '-',
            breakHours: '-',
            internalMeetingHours: '-',
            inCompletedHoursInSeconds: 0,
            breakHoursInSeconds: 0,
            internalMeetingHoursInSeconds: 0,
            reporter: element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName'),
            type: ''
          }
          if (incompletedHours > 0) {
            modalObject.inCompletedHours = this.secondsToHms(incompletedHours);
            modalObject.inCompletedHoursInSeconds = incompletedHours;
            modalObject.type = 'In Completed Hours';
          }
          if (breakHours > 14400) { // 4 Break Hours
            modalObject.breakHours = this.secondsToHms(breakHours);
            modalObject.breakHoursInSeconds = breakHours;
            modalObject.type = 'Break Hours';
          }
          if (internalMeetingHours > 10800) { // 3 Internal Meeting Hours
            modalObject.internalMeetingHours = this.secondsToHms(internalMeetingHours);
            modalObject.internalMeetingHoursInSeconds = internalMeetingHours;
            modalObject.type = 'Internal Meeting Hours';
          }
          if (modalObject.inCompletedHours != '-' || modalObject.breakHours != '-' || modalObject.internalMeetingHours != '-') {
            this.violationResults.push(modalObject);
            this.excelData.push({
              'User Name': modalObject.userName,
              'In Completed Hours': modalObject.inCompletedHours,
              'Break Hours': modalObject.breakHours,
              'Internal Meeting Hours': modalObject.internalMeetingHours,
              'Reporting To': modalObject.reporter,
            });
          }
        }
        else {
          this.violationResults.push({
            id: element.id,
            userName: element.get('firstName') + ' ' + element.get('lastName'),
            inCompletedHours: '08:00:00',
            breakHours: '-',
            internalMeetingHours: '-',
            inCompletedHoursInSeconds: 28800,
            breakHoursInSeconds: 0,
            internalMeetingHoursInSeconds: 0,
            reporter: element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName')
          });
          this.excelData.push({
            'User Name': element.get('firstName') + ' ' + element.get('lastName'),
            'In Completed Hours': '08:00:00',
            'Break Hours': '-',
            'Internal Meeting Hours': '-',
            'Reporting To': element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName'),
          });
        }
      }
      this.violationResults.sort(function (a, b) {
        return b.inCompletedHoursInSeconds - a.inCompletedHoursInSeconds;
      });
      this.violationCount = this.violationResults.length;
    }
    else {
      this.toastr.warning('Not an working day');
    }
  }

  exportAsXLSX() {
    this.excelService.exportAsExcelFile(this.excelData, 'Violations');
  }

  tabChange(tabIndex) {
    if (tabIndex == 0) {

    }
    if (tabIndex == 1) {
    }
  }

  async getHolidays() {
    this.nonWorkingDays = [];
    const currentYear = new Date().getFullYear();
    let holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    let holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', currentYear);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
      for (let months in holidayList) {
        if (holidayList[months].length != 0) {
          let parsedMonths = parseInt(months);
          holidayList[months].forEach(element => {
            const officialLeaves = new Date(currentYear, parsedMonths, element);
            const epochLeaves = officialLeaves.getTime();
            this.nonWorkingDays.push(epochLeaves);
          });
        }
      }
    }
    let date = new Date();
    let year = date.getFullYear();
    let totalMonths = 12;
    for (let i = 0; i < totalMonths; i++) {
      let k = i + 1;
      let daysInMonth = new Date(year, k, 0).getDate();
      for (let j = 0; j < daysInMonth; j++) {
        let datesAll = new Date(year, i, j);
        let dayOfWeek = datesAll.getDay();
        let dateOfMonth = datesAll.getDate();
        let isEvenWeek = Math.ceil(dateOfMonth / 7);
        let epochOddDates = datesAll.getTime();
        if (dayOfWeek == 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        }
      }
    }
    let previousYear = year - 1;
    let daysInMonthLast = new Date(previousYear, 12, 0).getDate();
    for (let d = 1; d <= daysInMonthLast; d++) {
      let lastdatesAll = new Date(previousYear, 11, d);
      let lastdayOfWeek = lastdatesAll.getDay();
      let lastdateOfMonth = lastdatesAll.getDate();
      let lastisEvenWeek = Math.ceil(lastdateOfMonth / 7);
      let lastepochOddDates = lastdatesAll.getTime();
      if (lastdayOfWeek == 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      } if (lastdayOfWeek == 6 && lastisEvenWeek % 2 != 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      }
    }
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  bindDropDown1(array) {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.label, value: a.label });
    });
    return dropDownItem;
  }

}
